<button mat-flat-button color="primary" (click)="openFilters()">
    <mat-icon>tune</mat-icon>
    <span>{{ 'menu.filters' | translate }}</span>
    <mat-icon iconPositionEnd>keyboard_arrow_up</mat-icon>
</button>